const getLinkWithoutTsPynRu = (value: string): string => value.replace(/\.ts\d+\.pyn\.ru/gi, '');

export default getLinkWithoutTsPynRu;
